import { useState } from 'react';
import Sidebar from './Sidebar';
import MobileSidebar from './MobileSidebar';
import Header from './Header';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div>
      <MobileSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <Sidebar />
      <Header setSidebarOpen={setSidebarOpen} />
      <main className='py-0 lg:pl-72'>
        <div className='px-0 sm:px-0 lg:px-0 h-screen relative'>{children}</div>
      </main>
    </div>
  );
};

export default Layout;
